import { IEmptyAlertBehavior } from "./IEmptyAlertBehavior";

export interface IEmptyAlertBehaviorSpecifiable {
  emptyAlertBehavior: IEmptyAlertBehavior;
}

export function instanceOfIEmptyAlertBehaviorSpecifiable(instance: any): instance is IEmptyAlertBehaviorSpecifiable {
  return instance
    && (instance.emptyAlertBehavior !== undefined);
}
